import React, { useEffect } from 'react'
import { Alert, Box, Checkbox } from '@indeed/ifl-components'

export const FLEX_DISABLED_WARNING_FLAG = 'incsts349_warn_flex_disabled_best_flexers'

export const FLEX_CASCADE_PREFERENCES_FLAG = 'pte_39738_cascade_flex_preferences'

export const FLEX_DISABLED_WARNING_MESSAGE =
  "Warning: this venue is set to “Don't offer to flex”. Offering to All Flexers will send this shift to the Flex marketplace against the client's preference."

export const FLEX_DISABLED_ACKNOWLEDGE_LABEL =
  "I understand this venue is set to “Don't offer to flex” and want to offer to flexers anyway."

export const FLEX_DISABLED_WARNING_TEST_ID = 'flex-disabled-warning'
export const FLEX_DISABLED_ACKNOWLEDGE_TEST_ID = 'flex-disabled-warning-acknowledge'

const WARNING_MESSAGE_ID = 'flex-disabled-warning-message'

type FlexDisabledWarningProps = {
  isAcknowledged: boolean
  onAcknowledge: (checked: boolean) => void
  onShown: () => void
}

export const FlexDisabledWarning = ({ isAcknowledged, onAcknowledge, onShown }: FlexDisabledWarningProps) => {
  useEffect(() => {
    onShown()
  }, [onShown])

  return (
    <Box data-testid={FLEX_DISABLED_WARNING_TEST_ID} sx={{ marginBlockStart: 2, marginBlockEnd: 2 }}>
      <Alert status="warning" type="polite" id={WARNING_MESSAGE_ID}>
        {FLEX_DISABLED_WARNING_MESSAGE}
      </Alert>
      <Box sx={{ marginBlockStart: 2 }}>
        <Checkbox
          label={FLEX_DISABLED_ACKNOWLEDGE_LABEL}
          checked={isAcknowledged}
          onChange={event => onAcknowledge(event.target.checked)}
          aria-describedby={WARNING_MESSAGE_ID}
          data-testid={FLEX_DISABLED_ACKNOWLEDGE_TEST_ID}
        />
      </Box>
    </Box>
  )
}
